// extracted by mini-css-extract-plugin
export default {"noLogo":"UserAvatar_noLogo_oFYC4","hasLogo":"UserAvatar_hasLogo_dfmOZ","hasBorder":"UserAvatar_hasBorder_vmHkV"};